<template>
  <main-content v-if="current_user.id">
    <kt-panel>
      <kt-panel-header>
        <kt-panel-header-toolbar>
          <span v-text="`${$t('label.advertising_banne_edit')} ${form_data.title}`"></span>
        </kt-panel-header-toolbar>
      </kt-panel-header>
      <kt-panel-body>
        <div>
          <form id="receipt_form"
                @submit.prevent="send($event)">
            <div class="p-3 my-2">
              <div>
                <kt-row class="mt-2">
                  <kt-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <kt-form-group>
                      <label for="title" v-text="$t('label.title')"></label>
                      <input
                          id="title"
                          name="title"
                          v-model="form_data.title"
                          class="form-control"
                          :placeholder="$t('banner.title_placeholder')"
                      >
                    </kt-form-group>
                  </kt-col>

                  <kt-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <kt-form-group>
                      <label for="link" v-text="$t('banner.link')"></label>
                      <input
                          id="link"
                          name="link"
                          v-model="form_data.link"
                          class="form-control"
                          :placeholder="$t('banner.link_placeholder')"
                      >
                    </kt-form-group>
                  </kt-col>


                  <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <kt-form-group>
                      <label for="image" v-text="$t('label.banner_image_upload')"></label>
                      <input
                          type="file"
                          ref="image"
                          id="image"
                          name="image"
                          class="form-control"
                          @change="onFileChange($event)"
                      >
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="12" md="6" lg="6" xl="6" v-if="url">
                    <div id="preview">
                      <div v-if="url" class="border rounded-lg p-3 img-thumbnail">
                        <button type="button" @click="removeImg()"
                                style="position: absolute"
                                class="btn btn-danger btn-sm btn-icon rounded-pill"><span
                            class="fa fa-window-close"></span></button>
                        <img v-if="url" :src="`${url}`"/>
                      </div>
                    </div>
                  </kt-col>
                </kt-row>

                <kt-row class="mt-1 mr-1  justify-content-md-end">
                  <button class="btn btn-primary  btn-sm" id="submit_btn">
                    <span class="fa fa-edit"></span>
                    {{ $t('btn.edit') }}
                  </button>

                </kt-row>
              </div>
            </div>
          </form>
        </div>
      </kt-panel-body>

    </kt-panel>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import {i18n} from "@/plugins/i18n";
import {bannerService} from "@/common/api.service";
import {bankId, bankIdStr} from "@/constants/bankId";
import {walletTransactionType} from "@/constants/walletTransactionType";
import $ from 'jquery'
import {KTApp} from "@/plugins/core/app";
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  name: "EditBanner",
  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),
    hashid() {
      return this.$route.params.hashid
    }
  },
  components: {MainContent},

  data() {
    return {
      form_data: {
        image: '',
        title: '',
        link: '',
      },
      url: null,
    }
  },

  methods: {
    removeImg() {
      this.url = '';
      this.form_data.image = '';
      this.$refs.image.value = null;
      this.$forceUpdate()
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);

      this.form_data.image = file

      this.$forceUpdate();
    },

    send(e) {
      let form = $(e.target);
      let btn = $('#submit_btn');

      let formData = new FormData();
      formData.append('title', this.form_data.title)
      formData.append('link', this.form_data.link)
      if (this.form_data.image instanceof File) {
        formData.append('image', this.form_data.image);
      }

      KTApp.progress(btn)

      bannerService.update(formData, this.hashid)
          .then(({data}) => {
            this.toastr.success(data.message)
            this.$router.back()
          })
          .catch(({response}) => {
            if (response.status === 400) {
              form.validate().showErrors(response.data.data)
            }
            this.toastr.error(response.data.message)
          }).finally(() => {
        KTApp.unprogress(btn)
      })
    },

    async getBanner() {
      try {
        const { data } = await bannerService.show(this.hashid)

        const banner = data.data;
        this.form_data.title = banner.title
        this.form_data.link = banner.link

        // برای preview عکس قبلی
        this.url = banner.image

      } catch (error) {
        console.error(error)
        this.$router.back()
      }
    },
  },
  mounted() {
    this.getBanner()
  },
}
</script>

<style scoped>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
}

#preview img {
  max-width: 100%;
  max-height: 450px;
}

.slider {
  background-color: #757575;
}

.slider.round {
  border-radius: 100px;
}

.slider.round:before {
  border-radius: 100px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 43px;
  height: 19px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #575757;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 1px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
</style>